export default __webpack_public_path__ + "static/media/banner_mobile.ea3d3f52.png";